import { ContextMenu } from "@/components/ui";
import type { MatterTaskPlan } from "@/lib/types";
import type { ReactNode } from "react";

type MatterTaskPlanContextMenuProps = {
  canDelete: boolean;
  canUpdate: boolean;
  onDelete: () => void;
  onEdit: () => void;
  plan: MatterTaskPlan;
  trigger: ReactNode;
};

export function MatterTaskPlanContextMenu({
  canDelete,
  canUpdate,
  onDelete,
  onEdit,
  plan,
  trigger,
}: MatterTaskPlanContextMenuProps) {
  return (
    <ContextMenu
      entityName="task plan"
      trigger={trigger}
      open={canUpdate ? { onSelect: onEdit } : false}
      copy={{ label: "Copy task plan title", value: plan.title }}
      delete={canDelete ? { onSelect: onDelete } : false}
    />
  );
}
